import React from "react"
import Input from "@kit/design/input"

export default ({ name, selector } = {}) => ({
  name,
  type: "font-size",
  component: ({ value, onChange }) => {
    return (
      <div>
        <Input type="number" value={value} onChange={onChange} />
      </div>
    )
  },
  css: value => {
    return `
      ${selector} {
        font-size: ${value}px;
      }
    `
  }
})
